export const languageText = (value) => {
  if (value) {
    const languageKey = value.split('_')[0]
    return languageKey
  }
  return value
}
